import useAuth from "../context/useAuth";
import { Navigate, Outlet } from "react-router-dom";

export default function RequirAuth() {
  const user = useAuth();

  return user.user?.username ? <Outlet /> : <Navigate to="/login" />;
}
